import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverSurfaceSeparatorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const POPOVER_SURFACE_SEPARATOR_HIDDEN_COLOR = "transparent";

const stylesheet = StyleSheet.create({
    separator: {
        flexShrink: 0
    }
});

export const useStyles = ({
    isHighlighted,
    borders,
    colors,
    spaces
}: PopoverSurfaceSeparatorDynamicStyleType) => {
    const styles = {
        separator: {
            backgroundColor: isHighlighted ? POPOVER_SURFACE_SEPARATOR_HIDDEN_COLOR : colors.content.border.subtle,
            marginHorizontal: -spaces.spacingXs,
            marginVertical: spaces.spacingXs,
            height: borders.separator
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
